import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiLineClampDirective } from './fi-line-clamp.directive';

@NgModule({
    declarations: [FiLineClampDirective],
    imports: [CommonModule],
    exports: [FiLineClampDirective],
})
export class FiLineClampModule {}
